export enum EDefferedPromiseState {
    PENDING = 'pending',
    FULFILLED = 'fulfilled',
    REJECTED = 'rejected'
}
export class DeferredPromise<T = void> {
    public state: EDefferedPromiseState;
    public promise: Promise<T>;
    public resolve!: (value: T | PromiseLike<T>) => void;
    public reject!: (reason?: any) => void;
    private _resolved = false;

    constructor() {
        this.reset();
    }

    public reset(): void {
        this.state = EDefferedPromiseState.PENDING;
        this.promise = new Promise<T>((resolve, reject) => {
            this.resolve = (value: T | PromiseLike<T>) => {
                if (this.state !== EDefferedPromiseState.PENDING) return;

                this.state = EDefferedPromiseState.FULFILLED;
                resolve(value);
            };

            this.reject = (reason?: any) => {
                if (this.state !== EDefferedPromiseState.PENDING) return;

                this.state = EDefferedPromiseState.REJECTED;
                reject(reason);
            };
        });
    }
}
